import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    
    faInstagram,
    faBehance,
    faDribbble,
    faLinkedin
  } from "@fortawesome/free-brands-svg-icons";

  import './Socialicons.css';

export default function Socialicons() {
  return (
    
      <div class="social-container">
      <a href="https://www.behance.net/akilopelumipelz"
        className="youtube social">
        <FontAwesomeIcon icon={faBehance} size="1x" />
      </a>
      <a href="https://www.linkedin.com/in/akilo-pelumi"
  className="facebook social">
  <FontAwesomeIcon icon={faLinkedin} size="1.9x" />
</a>
<a href="https://dribbble.com/akilopelumi" className="twitter social">
  <FontAwesomeIcon icon={faDribbble} size="1.9x" />
</a>
<a href="https://www.instagram.com/adeolu.ui"
  className="instagram social">
  <FontAwesomeIcon icon={faInstagram} size="1x" />
</a>
</div>
    
  );
}

